import React from 'react';
import { CanopiLogo, CanopiWordmark } from './CanopiLogo';
import { ExternalLink, Mail } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();

  const footerLinks = [
    {
      title: t('footer.product'),
      links: [
        { label: t('footer.links.solution'),  href: '#solution' },
        { label: t('footer.links.platform'),  href: '#platform' },
        { label: t('footer.links.roadmap'),   href: '#roadmap' },
      ],
    },
    {
      title: t('footer.company'),
      links: [
        { label: t('footer.links.about'),    href: '#about' },
        { label: t('footer.links.research'), href: '#research' },
        { label: t('footer.links.contact'),  href: '#interest' },
      ],
    },
    {
      title: t('footer.getStarted'),
      links: [
        { label: t('footer.links.pilot'),    href: '#interest' },
        { label: t('footer.links.waitlist'), href: '#interest' },
        { label: t('footer.links.login'),    href: '/login' },
      ],
    },
  ];

  return (
    <footer className="relative py-16 px-6 sm:px-12 lg:px-24 border-t border-[#3D5638]/20" data-testid="footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          {/* Logo + tagline */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-4">
              <CanopiLogo size={28} className="text-white/80" />
              <CanopiWordmark className="text-sm" />
            </div>
            <p className="text-sm text-white/40 leading-relaxed max-w-sm">
              {t('footer.tagline')}
            </p>
            <div className="flex gap-4 mt-5">
              <a
                href="https://www.linkedin.com/in/ana-gabriela-larios"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="text-white/30 hover:text-[#BDD6B5] transition-colors"
              >
                <ExternalLink size={18} />
              </a>
              <a
                href="mailto:hello@canopitech.ai"
                data-testid="footer-email"
                className="text-white/30 hover:text-[#BDD6B5] transition-colors"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((col, i) => (
            <div key={i} className="md:col-span-2">
              <h4 className="font-mono text-xs tracking-widest uppercase text-[#BDD6B5]/50 mb-4">{col.title}</h4>
              <ul className="space-y-2">
                {col.links.map((link, j) => (
                  <li key={j}>
                    <a
                      href={link.href}
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                      className="text-sm text-white/40 hover:text-white/70 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-[#3D5638]/15 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/25">
            &copy; {new Date().getFullYear()} Canopi Technologies. All rights reserved.
          </p>
          <p className="text-xs text-white/20 italic">
            {t('footer.slogan')}
          </p>
        </div>
      </div>
    </footer>
  );
}
